export const LISTING_STATUSES = [
  "draft",
  "active",
  "needs_review",
  "paused",
  "sold",
  "archived",
  "rejected",
];

export const AVAILABILITY_STATUSES = [
  "available",
  "pending_confirmation",
  "reserved",
  "sold",
  "unknown",
];

export const TRANSMISSION_OPTIONS = [
  { value: "automatic", label: "Automática" },
  { value: "manual", label: "Mecánica" },
];

export const FUEL_OPTIONS = [
  { value: "gasolina", label: "Gasolina" },
  { value: "diesel", label: "Diésel" },
  { value: "hibrido", label: "Híbrido" },
  { value: "electrico", label: "Eléctrico" },
];

const FUEL_FORM_ALIASES = {
  gasoline: "gasolina",
  gasolina: "gasolina",
  diesel: "diesel",
  hybrid: "hibrido",
  hibrido: "hibrido",
  electric: "electrico",
  electrico: "electrico",
};

const FUEL_SAVE_ALIASES = {
  gasolina: "gasoline",
  hibrido: "hybrid",
  electrico: "electric",
};

export function normalizeFuelForForm(value) {
  return FUEL_FORM_ALIASES[value] || value || "gasolina";
}

export function normalizeFuelForSave(value) {
  return FUEL_SAVE_ALIASES[value] || value;
}

export const BODY_TYPE_OPTIONS = ["SUV", "Sedán", "Hatchback", "Pickup", "Camioneta", "Otro"];

export const SOAT_STATUSES = ["valid", "expired", "unknown", "not_provided"];

export const TECNOMECANICA_STATUSES = ["valid", "expired", "unknown", "not_provided"];

export const DOCUMENT_STATUS_LABELS = {
  valid: "Vigente",
  expired: "Vencido",
  unknown: "Desconocido",
  not_provided: "No informado",
};

export const STATUS_LABELS = {
  draft: "Borrador",
  active: "Activo",
  needs_review: "Revisión",
  paused: "Pausado",
  sold: "Vendido",
  archived: "Archivado",
  rejected: "Rechazado",
  available: "Disponible",
  pending_confirmation: "Confirmar",
  reserved: "Reservado",
  unknown: "Desconocido",
};

export const SORT_OPTIONS = [
  { value: "updated_desc", label: "Actualizado recientemente" },
  { value: "created_desc", label: "Más nuevo" },
  { value: "price_desc", label: "Precio mayor" },
  { value: "price_asc", label: "Precio menor" },
  { value: "year_desc", label: "Año más reciente" },
  { value: "mileage_asc", label: "Menor kilometraje" },
  { value: "quality_asc", label: "Calidad más baja" },
];

export function formatListingStatus(status) {
  return STATUS_LABELS[status] || status || "—";
}

export function qualityBadgeClass(score) {
  if (score >= 85) return "admin-badge--success";
  if (score >= 70) return "admin-badge--info";
  if (score >= 50) return "admin-badge--warning";
  return "admin-badge--danger";
}

export const DEALER_CONTEXT_KEY = "automap_dealer_portal_dealer_id";

export function getDealerContextId() {
  try {
    return sessionStorage.getItem(DEALER_CONTEXT_KEY) || "";
  } catch {
    return "";
  }
}

export function setDealerContextId(dealerId) {
  try {
    if (dealerId) sessionStorage.setItem(DEALER_CONTEXT_KEY, dealerId);
    else sessionStorage.removeItem(DEALER_CONTEXT_KEY);
  } catch {
    // ignore
  }
}

export function trackInventoryEvent(eventType, metadata = {}) {
  if (process.env.NODE_ENV === "development") {
    // eslint-disable-next-line no-console
    console.debug("[inventory-event]", eventType, metadata);
  }
}
